import jsPDF from "jspdf";
import html2canvas from "html2canvas";

// Render a DOM node into a single-page A4 jsPDF document (scaled to fit).
export async function renderInvoicePdf(node) {
  const canvas = await html2canvas(node, { scale: 1.5, useCORS: true, backgroundColor: "#ffffff" });
  // JPEG + compression keeps the file small (PNG produced ~8MB files)
  const img = canvas.toDataURL("image/jpeg", 0.72);
  const pdf = new jsPDF({ orientation: "p", unit: "mm", format: "a4", compress: true });

  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();
  const ratio = canvas.width / canvas.height;

  // Fit to width first; if that overflows the page height, fit to height instead.
  let w = pageW;
  let h = w / ratio;
  if (h > pageH) {
    h = pageH;
    w = h * ratio;
  }
  const x = (pageW - w) / 2;
  const y = (pageH - h) / 2;
  pdf.addImage(img, "JPEG", x, y, w, h, undefined, "FAST");
  return pdf;
}

// Return just the base64 payload (no data-uri prefix) for emailing.
export async function renderInvoicePdfBase64(node) {
  const pdf = await renderInvoicePdf(node);
  const uri = pdf.output("datauristring");
  return uri.split(",")[1];
}
